import { State } from '../reducers/rootReducer'

const shouldNavigateToTargetSelector = (state: State): boolean => state.shouldNavigateToTarget

export default shouldNavigateToTargetSelector
